import type { MonospaceSettings } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { SINGLETON_KEY } from '#layers/base/public';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const Settings = withItemType<MonospaceSettings>().defineCollection({
	getKey: () => SINGLETON_KEY,
	name: 'MonospaceSettings',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		singleton: true,
		defaultFields: ['id'],
		endpoint: 'settings',
	},
});
